import {
  FETCH_PROGRAMMES_SEARCH,
  SearchFetchProgrammesQuery,
  SearchFetchProgrammesQueryVariables,
} from '@edwin-group/cj-graphql';
import { useMemo } from 'react';
import { useQueryCacheAndNetwork } from '@/hooks/useQueryCacheAndNetwork';
import { buildProgrammesQueryVariables, SearchFilters } from '../utils/query-variables';

export const useProgrammesSearch = (filters: SearchFilters, shouldSkip: boolean) => {
  const queryVariables = useMemo(() => buildProgrammesQueryVariables(filters), [filters]);

  const {
    data: result,
    fetchMore,
    isInitialLoading,
  } = useQueryCacheAndNetwork<SearchFetchProgrammesQuery, SearchFetchProgrammesQueryVariables>(
    FETCH_PROGRAMMES_SEARCH,
    {
      variables: queryVariables,
      skip: shouldSkip,
    },
  );

  const programmesList = useMemo(
    () =>
      result?.programmes?.data.map((programme) => ({
        id: programme.id,
        ...programme.attributes,
      })),
    [result?.programmes?.data],
  );

  return {
    programmesList,
    fetchMore,
    isLoading: isInitialLoading,
    queryVariables,
    result,
  };
};
